// extracted by mini-css-extract-plugin
var _1 = "ScrollSliderButtons-moduleScrollSliderNextButton__kQZNe";
var _2 = "ScrollSliderButtons-moduleScrollSliderPrevButton__MlTXy";
export { _1 as "ScrollSliderNextButton", _2 as "ScrollSliderPrevButton" }
